<template>

    <v-card class="card-parent">
      <div class="features">
        <v-form validation ref="form" v-model="valid" >
          <div class="title-feature">
            <div class="ml-4" style="font-weight: bold;font-size: 1.5rem">
              عنوان:
            </div>
            <v-text-field
            class="title-input"
            style="width: 28%"
            label="عنوان"
            :rules="[rules3]"
            placeholder="عنوان"
            v-model="title"
            solo
            hide-details
          ></v-text-field>
          </div>
          <div class="description">
            <div style="font-weight: bold;font-size: 1.5rem">متن ویژگی های مورد نظر خود را وارد کنید :</div>
            <v-textarea
              class="text-input"
              counter
              row-height="5"
              :rules="[rules1]"
              v-model="text"
              rows="3"
            ></v-textarea>
          </div>
          <v-divider style="margin: 20px 0"></v-divider>

        </v-form>

        <div class="button">
          <v-btn :loading="loadingSend" v-if="!isEdit" class="button-style"  :disabled="!valid" @click="send()">فرستادن</v-btn>
          <v-btn :loading="loadingSend" v-else class="button-style"  :disabled="!valid" @click="update()">ویرایش</v-btn>
          <v-btn class="button-style"  @click="eybiYokh()">بیخیال</v-btn>

        </div>
      </div>
    </v-card>

</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import {setFeatures, putFeatures} from "../../../api/mainpage/features";

    export default {
        name: "features",
      data:()=>({
        loadingSend:false,
        files:[],
        rules1: v =>{
          if(v !== '' && v.length <=250)
          {
            return true
          }
          else
          {
            return `متن وارد شده باید کمتر از ${250} کاراکتر باشد`
          }
        },
        rules2: value =>{
          if(!!value && value.length !== 0 ||value.size  < 50000000)
          {
            return true
          }
          else
            return 'ویدیو مورد نظر باید کمتر از 50 مگابایت اندازه داشته باشد'
        },
        rules3: v =>{
          if(v !== '' && v.length <=50)
          {
            return true
          }
          else
          {
            return 'متن وارد شده باید کمتر از 50 کاراکتر باشد'
          }
        },
        title:'',
        text:'',
        videoPath:'',
        isEdit:true,
        valid:true,
        objectFeatures:{}
      }),
      methods:{
        ...mapActions({
          getFeaturesReq:'featuresStore/fetchFeatures',
          snackBarAction:'snackBar/snackBarAction'
        }),
        async send(){
          this.loadingSend = true
          try{
           let params = {
               title : this.title,
                text : this.text,
            }
          await   setFeatures(params).then(()=>{
            this.isEdit = true;
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })}catch (e) {
///
          }
          this.getFeaturesReq()
          this.loadingSend = false
        },
        async update(){
          this.loadingSend = true
          try {
            let params = {
              title : this.title,
              text : this.text,
              id:this.originalFeatures[0].id
            }
          await   putFeatures(params,this.originalFeatures[0].id).then(()=>{
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
          }catch (e) {
            ////
          }
          this.getFeaturesReq()
          this.loadingSend = false
        },

       async eybiYokh(){
          await   this.getFeaturesReq().then(()=>{
            if(this.originalFeatures.length === 0 )
            {
              this.isEdit = false
            }
            else{
              this.isEdit = true
              this.title  = this.originalFeatures[0].title
              this.text = this.originalFeatures[0].text
              this.videoPath = this.originalFeatures[0].videoPath
            }
          })
        },

      },
      computed: {
        ...mapGetters({
          originalFeatures: 'featuresStore/get_features',
        })
      },
    async  mounted () {
          await   this.getFeaturesReq().then(()=>{
            if(this.originalFeatures.length === 0 )
            {
              this.isEdit = false
            }
            else{
              this.isEdit = true
              this.title  = this.originalFeatures[0].title
              this.text = this.originalFeatures[0].text
              this.videoPath = this.originalFeatures[0].videoPath
            }
          })

      },
      updated() {
      }
    }
</script>

<style scoped>
  .card-parent{
    width: 85%;
    margin: 0 auto;
  }
  .title-feature{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: max-content
  }
  .features{
    display: flex;
    flex-direction: column;
    padding: 50px;
    padding-bottom: 20px;
  }
  .input{
    direction: ltr;
  }
  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }
  .video-upload .v-input{
    margin-right: 100px;
  }
  .link-input{
    width: 28%;
  }
  .description{
    margin-top: 3rem;
  }
  .button{
    display: flex;
    flex-direction: row-reverse;
    align-self: flex-end;
    margin-top: 20px;
  }
  .button-style{
    width: 91px;
  }

</style>
